import { render, staticRenderFns } from "./ProxyConfigView.vue?vue&type=template&id=40c427d5&scoped=true"
import script from "./ProxyConfigView.vue?vue&type=script&lang=js"
export * from "./ProxyConfigView.vue?vue&type=script&lang=js"
import style0 from "./ProxyConfigView.vue?vue&type=style&index=0&id=40c427d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c427d5",
  null
  
)

export default component.exports